<div class="option-container">
  <label for="issueNature" class="form-label ps-2">{{ label }}<sup>*</sup></label>
  <div class="multi-select-container" *ngIf="!addingNewOption">
    <ng-multiselect-dropdown
      id="multi"
      [placeholder]="'Select ' + label"
      [settings]="dropdownSettings"
      [data]="options"
      [(ngModel)]="selectedOptions"
      (onSelect)="onItemSelect($event)"
      (onDeSelect)="onItemDeSelect($event)"
      (onSelectAll)="onSelectAll($event)"
      (onDeSelectAll)="onDeSelectAll($event)">
    </ng-multiselect-dropdown>

    <button (click)="addingNewOption = true" class="add-new-option-btn">
      <span class="icon-plus">+</span>
    </button>
  </div>

  <div *ngIf="addingNewOption" class="new-option">
    <input [(ngModel)]="newOption.key1" placeholder="Enter Option Name" class="form-control new-option-input" />
    <button class="add-btn" (click)="addNewOption()">
      <span class="icon-tick">✔</span>
    </button>
    <button class="cancel-btn" (click)="cancelNewOption()">
      <span class="icon-cross">✘</span>
    </button>
  </div>
</div>
